import * as React from "react";
import { FramesEcommProvider, EcommFacetProvider, FramesStickyCTA, FramesEcommContent, useProductDetailSlots, ProductDetailFullWidth, FrameMeasurements, ProductDetailStack, ProductDetailDescription, ProductDetailOpticsFeatures, ProductDetailDisclaimer, ProductDetailDrawerStack, ProductDetailSpecification, ProductDetailManufacturerDrawer, ProductDetailReviewsDrawer, ProductImageGallery, mapServerToFramesProduct, getFramesBySlug } from "@grandvisionhq/fun-products";
import { P as ProductPageLayoutBase, a as ProductPageBase, c as defaultProductWithAFrameFacetConfig, f as fetchProductConfigBySlug, h as handleValidations } from "../../ProductPageLayoutBase.js";
import { a as defaultFramesFlatFacetConfig } from "../../default-flat-facet-configs.js";
import { CmsComponentSlot } from "@grandvisionhq/bloomreach";
import { V as VirtualMirrorContainer } from "../../VirtualMirrorContainer.js";
const EcommContent = FramesEcommContent;
const ImageGallery = () => /* @__PURE__ */ React.createElement(
  ProductImageGallery,
  {
    slots: {
      TopLeft: VirtualMirrorContainer
    }
  }
);
const PrimaryProductInfo = (props) => {
  return /* @__PURE__ */ React.createElement(ProductDetailStack, { ...props }, /* @__PURE__ */ React.createElement(ProductDetailDescription, { className: "product-detail-stack__description" }, /* @__PURE__ */ React.createElement(ProductDetailOpticsFeatures, null)), /* @__PURE__ */ React.createElement(ProductDetailDisclaimer, { className: "product-detail-stack__disclaimer" }), /* @__PURE__ */ React.createElement(ProductDetailDrawerStack, { className: "product-detail-stack__drawer-stack" }, /* @__PURE__ */ React.createElement(ProductDetailSpecification, null), /* @__PURE__ */ React.createElement(ProductDetailManufacturerDrawer, null), /* @__PURE__ */ React.createElement(ProductDetailReviewsDrawer, null)));
};
const SecondaryProductInfo = () => {
  const { Slots: OpcoSlots } = useProductDetailSlots();
  return /* @__PURE__ */ React.createElement(ProductDetailFullWidth, null, /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/row-pdp-container" }), /* @__PURE__ */ React.createElement(FrameMeasurements, null), OpcoSlots.SecondaryProductInfoSlot && /* @__PURE__ */ React.createElement(OpcoSlots.SecondaryProductInfoSlot, null));
};
const FramesDetailPage = () => {
  return /* @__PURE__ */ React.createElement(FramesEcommProvider, null, /* @__PURE__ */ React.createElement(EcommFacetProvider, null, /* @__PURE__ */ React.createElement(
    ProductPageLayoutBase,
    {
      EcommContent,
      ImageGallery,
      PrimaryProductInfo,
      StickyCta: FramesStickyCTA,
      SecondaryProductInfo
    }
  )));
};
const Page = ({
  facetConfigList,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(
    ProductPageBase,
    {
      ...props,
      facetConfigList: facetConfigList ?? defaultProductWithAFrameFacetConfig
    },
    /* @__PURE__ */ React.createElement(FramesDetailPage, null)
  );
};
Page.getInitialProps = async (ctx) => {
  const productConfig = await fetchProductConfigBySlug(
    ctx,
    getFramesBySlug,
    mapServerToFramesProduct,
    ctx.pageConfig?.facetConfigList ?? defaultProductWithAFrameFacetConfig,
    ctx.pageConfig?.flatFacetConfigList ?? defaultFramesFlatFacetConfig
  );
  if ("failure" in productConfig) {
    return handleValidations(productConfig, `Error while initializing Frames PDP`);
  }
  const { product, activeVariant, sku, slug, bloomreachPathOverride } = productConfig;
  return {
    sku,
    slug,
    product,
    activeVariant,
    bloomreachPathOverride
  };
};
export {
  Page
};
//# sourceMappingURL=frames.js.map
